import React from 'react';
import PropTypes from 'prop-types';
import CrumbName from './CrumbName';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs';

function LinkedCrumb({currentPage, hasDivider, name, node, onClickName, position, url}) {
    return (
        <li className="Breadcrumb__li" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <CrumbName currentPage={currentPage} name={name} node={node} onClick={onClickName} positionContent={position} url={url}/>
            {hasDivider && <SVGIcon markup={CHEVRON_RIGHT__12} inlineFlex className="Breadcrumb__divider" aria-hidden/>}
        </li>
    );
}

LinkedCrumb.propTypes = {
    currentPage: PropTypes.bool,
    hasDivider: PropTypes.bool,
    name: PropTypes.string.isRequired,
    node: PropTypes.node,
    onClickName: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired
};

export default LinkedCrumb;
